'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_ScheduledMealPreferences(breakFastTime, lunchTime, dinnerTime, snackTime, otherMealTime, breakfastDuration, lunchDuration, dinnerDuration, snackDuration, otherMealDuration) {
  this.m6 = null;
  this.mb = null;
  this.m9 = null;
  this.mf = null;
  this.md = null;
  this.m7 = null;
  this.ma = null;
  this.m8 = null;
  this.me = null;
  this.mc = null;
  this.m6 = breakFastTime;
  this.mb = lunchTime;
  this.m9 = dinnerTime;
  this.mf = snackTime;
  this.md = otherMealTime;
  this.m7 = breakfastDuration;
  this.ma = lunchDuration;
  this.m8 = dinnerDuration;
  this.me = snackDuration;
  this.mc = otherMealDuration;
}
export { $c_Lmealorama_ScheduledMealPreferences as $c_Lmealorama_ScheduledMealPreferences };
$p = $c_Lmealorama_ScheduledMealPreferences.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ScheduledMealPreferences;
/** @constructor */
function $h_Lmealorama_ScheduledMealPreferences() {
}
export { $h_Lmealorama_ScheduledMealPreferences as $h_Lmealorama_ScheduledMealPreferences };
$h_Lmealorama_ScheduledMealPreferences.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 1239451582, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_ScheduledMealPreferences)) {
    var x = this.m6;
    var x$2 = x$0.m6;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.mb;
      var x$4 = x$0.mb;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.m9;
      var x$6 = x$0.m9;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$7 = this.mf;
      var x$8 = x$0.mf;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.md;
      var x$10 = x$0.md;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.m7;
      var x$12 = x$0.m7;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.ma;
      var x$14 = x$0.ma;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$15 = this.m8;
      var x$16 = x$0.m8;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.me;
      var x$18 = x$0.me;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$19 = this.mc;
      var x$20 = x$0.mc;
      return ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 10;
});
$p.r = (function() {
  return "ScheduledMealPreferences";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.m6;
      break;
    }
    case 1: {
      return this.mb;
      break;
    }
    case 2: {
      return this.m9;
      break;
    }
    case 3: {
      return this.mf;
      break;
    }
    case 4: {
      return this.md;
      break;
    }
    case 5: {
      return this.m7;
      break;
    }
    case 6: {
      return this.ma;
      break;
    }
    case 7: {
      return this.m8;
      break;
    }
    case 8: {
      return this.me;
      break;
    }
    case 9: {
      return this.mc;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_ScheduledMealPreferences(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jT)));
}
export { $isArrayOf_Lmealorama_ScheduledMealPreferences as $isArrayOf_Lmealorama_ScheduledMealPreferences };
var $d_Lmealorama_ScheduledMealPreferences = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ScheduledMealPreferences, "mealorama.ScheduledMealPreferences", ({
  jT: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_ScheduledMealPreferences as $d_Lmealorama_ScheduledMealPreferences };
//# sourceMappingURL=mealorama.-Scheduled-Meal-Preferences.js.map
